
import { HttpClient } from '@angular/common/http';
import {  AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { FormatDataTableGlobalFive } from 'src/app/web/util/formatDataTable';
import Swal from 'sweetalert2';
import { ApiServiceProject } from '../../../../../apis/ApiServiceProject';
import { ErrorService } from 'src/app/shared/services/errors.service';
import * as moment from 'moment';

@Component({
  selector: 'project-step-2',
  templateUrl: './step2-project.component.html',
  styleUrls: ['./../../create-project.component.scss']
})
export class ProjectStep2Component implements  AfterViewInit, OnDestroy, OnInit  {
@ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  dtTrigger = new Subject();
  listStage= []
  listStado=[]
  listaEtapas=[]
  idProject
  dtOptions: DataTables.Settings = {};
  step:number = 0
  title="Datos"
  Step2form: FormGroup;
  private apiService: ApiServiceProject;
  constructor(
    private http: HttpClient,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private errorService:ErrorService
  ) { 
   this.route.params.subscribe((params) => {
      this.idProject = params['id'];
    });
  }

  ngOnInit(): void {
    this.spinner.show()
    this.Step2form = this.fb.group({
    projects_id:[''],
    stages_id:[''],
    state:[''],
    start_date:[''],
    end_date:[''],
    });
    this.dtOptions = FormatDataTableGlobalFive();
    this.apiService = new ApiServiceProject(this.http);


     this.apiService.getService(`list-option-create-project-datos`).subscribe({
      next: (data) => {
        if (data) {
          this.listStage = data['listStage'];
          this.listStado = data['listStado'];
          this.infoServi();
        } else {
          this.spinner.hide()
          Swal.fire({title:data.error,text: '',icon: 'error',heightAuto: false});
        }
      },
      error: (error) => {
        this.errorService.error(error);
      }
    })
    
  }

  infoServi(){
    this.apiService.getService("info-project-datos-step-two?id=" + this.idProject).subscribe({
      next: (rs:any) => {
        if (rs.code == null) {
          this.listaEtapas = rs.listStageTwo
          this.spinner.hide()
          this.rerender();
        }else{
          this.spinner.hide()
          Swal.fire({title:rs.error,text: '',icon: 'error',heightAuto: false});
        }
        
      },
      error: (error) => {
        this.errorService.error(error);
      }
    });
  }

 

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
  formSubmit(){
    
    this.spinner.show()
    let startDate = moment(this.Step2form.value.start_date).format("DD-MM-YYYY")

    let endDate = moment(this.Step2form.value.end_date).format("DD-MM-YYYY")

    let post = {
       projects_id:Number( this.idProject),
       stages_id:Number(this.Step2form.value.stages_id),
       state:Number(this.Step2form.value.state),
       start_date:startDate,
       end_date:endDate,
    }
    this.apiService.postService(`create-project-datos-step-two`,post).subscribe({
       next: (data) => {
         if (data) {
         Swal.fire({title: data.message ,text: '',icon: 'success',heightAuto: false}).then(()=>{
            location.reload();
         })

           this.spinner.hide();
          } else {
           this.spinner.hide()
           Swal.fire({title:data.error,text: '',icon: 'error',heightAuto: false});
         }
      },
     error: (error) => {
      this.errorService.error(error);
     }})
  }
  stageDelete(id:any){
      Swal.fire({
                title: 'Eliminar',
                text: '¿Desea eliminar registro?',
                icon: 'warning',
                showCancelButton:true,
                confirmButtonText: 'Aceptar',
                cancelButtonText:"No, cancelar",
                heightAuto: false
              }).then((res) => {
                if (res.isConfirmed) {
                  this.spinner.show()
                  this.apiService.deleteService('delete-project-datos-step-two?id=' + id).subscribe({
                    next: (rs: any) => {
                      if (rs) {
                        this.spinner.hide();
                        Swal.fire({title:'Exito!',text: 'Se ha eliminado con exito!',icon: 'success',heightAuto: false}).then(()=>{
                          location.reload()
                        })
                        
                      } else {
                          this.spinner.hide();
                          Swal.fire({
                          title:  rs.error,
                          text: '',
                          icon: 'error',
                          heightAuto: false
                          }); } },
                    error: (error) => {
                      this.errorService.error(error);
                    },});
                }
                else if ( res.dismiss === Swal.DismissReason.cancel){
                  Swal.fire({
                    title: 'Cancelado',
                    text: 'Operación cancelada.',
                    icon: 'error',
                    heightAuto: false
                    })

                }
              });
    
    
  }
  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

}
